import {createAsyncThunk, createEntityAdapter, createSlice} from '@reduxjs/toolkit';
import agent from '../agent/agent';

export const subscriptionsAdapter = createEntityAdapter();

export const fetchSubscriptions = createAsyncThunk('subscription/fetchAll', (data, {getState}) => agent
		.get(`${getState().status.apiUrl}/subscription/collection`)
		.set('Accept', 'application/json')
		.then((response) => response.body)
		.catch((error) => error));

export const fetchSubscription = createAsyncThunk('account/fetchAccount', (options, {getState}) =>
	agent
		.get(`${getState().status.apiUrl}/subscription/get`)
		.query({id: options.id})
		.set('Accept', 'application/json')
		.then((response) => response.body)
		.catch((error) => error)
);
export const updateSubscription = createAsyncThunk('subscription/update', (options, {getState}) =>
	agent
		.put(`${getState().status.apiUrl}/subscription/update`)
		.send(options)
		.set('Accept', 'application/json')
		.then((response) => response.body)
		.catch((error) => error)
);

export const subscriptionSlice = createSlice({
	name: 'subscription',
	initialState: {
		loading: '',
		error: null,
		subscriptions: subscriptionsAdapter.getInitialState(),
		pagination: {}
	},
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(fetchSubscriptions.pending, (state, action) => {
			state.loading = 'loading';
			state.error = null;
		});
		builder.addCase(fetchSubscriptions.fulfilled, (state, action) => {
			state.loading = 'idle';
			state.error = null;
			subscriptionsAdapter.removeAll(state.subscriptions);
			subscriptionsAdapter.upsertMany(state.subscriptions, action.payload.collection.items);
		});
		builder.addCase(fetchSubscriptions.rejected, (state, action) => {
			state.loading = 'idle';
			state.error = action.error.message;
		});
		builder.addCase(fetchSubscription.pending, (state, action) => {
			state.loading = 'loading';
			state.error = null;
		});
		builder.addCase(fetchSubscription.fulfilled, (state, action) => {
			state.loading = 'idle';
			state.error = null;
			const metadata = {};
			if (action.payload.item.metadata) {
				for (const key of Object.keys(action.payload.item.metadata)) {
					metadata[key] = action.payload.item.metadata[key];
				}
			}
			const item = {
				...action.payload.item,
				...metadata,
				metadata: JSON.stringify(action.payload.item.metadata, null, 2)
			};
			subscriptionsAdapter.upsertOne(state.subscriptions, item);
		});
		builder.addCase(fetchSubscription.rejected, (state, action) => {
			state.loading = 'idle';
			state.error = action.error.message;
		});

		builder.addCase(updateSubscription.fulfilled, (state, action) => {
			state.status = 'idle';
			state.error = null;
			subscriptionsAdapter.upsertOne(state.subscriptions, action.payload.item);
		});
		builder.addCase(updateSubscription.pending, (state, action) => {
			state.status = 'loading';
			state.error = null;
		});
		builder.addCase(updateSubscription.rejected, (state, action) => {
			state.status = 'error';
			state.error = action.error.message;
		});
	},
});

export const {
	selectById: selectSubscriptionById,
	selectIds: selectSubscriptionIds,
	selectEntities: selectSubscriptionEntities,
	selectAll: selectAllSubscriptions,
	selectTotal: selectTotalSubscriptions,
} = subscriptionsAdapter.getSelectors((state) => state.subscription.subscriptions);

export default subscriptionSlice.reducer;
